<template>
  <div>
    <div class="form-row">
      <div class="form-group col-md-6">
        <br>
        <label>เพิ่มวงเงินค้ำประกันจำนวนเงิน(บาท)</label>

        <vue-numeric
          separator=","
          v-bind:precision="2"
          v-model="addLgAmt"
          name="addLgAmt"
          class="form-control"
          placeholder="กรุณากรอกจำนวน"
          
          @blur="calSumLgAmt($event.target.value)"


          v-validate="{required:true,min_value:1}"
          :class="{'input': true, 'is-danger': errors.has('lgAmt') }"
        ></vue-numeric>

        <span v-show="errors.has('addLgAmt')" class="help is-danger">จำนวนเงินค้ำประกัน ไม่ถูกต้อง</span>
      </div>
      <div class="form-group col-md-6">
        <br>
        <label>รวมเป็นวงเงินค้ำประกัน(บาท)</label>

        <vue-numeric
          separator=","
          v-bind:precision="2"
          v-model="sumLgAmt"
          name="sumLgAmt"
          class="form-control"
          v-validate="{required:true,min_value:1}"
          disabled
          
        ></vue-numeric>
      </div>
    </div>

    <div class="form-row"  v-if="this.reqType !== 4">

      <div class="form-row">
              <div class="form-group no-label col-md-2"><label>ตั้งแต่วันที่</label></div>
              <div class="form-group no-label col-md-3">
               <date-picker
                  v-model="addPeriodStartDate"
                  name="addPeriodStartDate"
                  lang="th"
                  format="DD/MM/YYYY"
                  data-vv-as="ตั้งแต่วันที่"
                  placeholder
                  disabled
                ></date-picker>
              </div>

              
              <div class="form-group no-label col-md-2"><label>ถึงวันที่</label></div>
              <div class="form-group no-label col-md-3">
                
                <date-picker
                  v-model="addPeriodEndDate"
                  name="addPeriodEndDate"
                  lang="th"
                  format="DD/MM/YYYY"
                  placeholder
                  disabled
                  ></date-picker>
              </div>
            </div>
          </div>
  </div>

</template>

<script>
import moment from "moment";
//import DatePicker from "vue2-datepicker";
import DatePicker from "@/resources/datepicker/vue2-datepicker";
import { apiClient } from "@/utils/apiClient";

export default {
  inject: ["$validator"],
  props: ["reqType", "commNo", "lgType","appVo","oldperiodEndDate","feeAmt"],
  data() {
    return {
      addLgAmt: "",
      sumLgAmt: "",
      addPeriodStartDate: "",
      addPeriodEndDate: "",
    };
  },
  mounted() {
    this.sumLgAmt = this.appVo.lgAmt;
    if(this.reqType == 3){
      this.addPeriodStartDate = moment(new Date(),"DD/MM/YYYY");
      this.addPeriodEndDate = this.oldperiodEndDate;      
    }
  },
  methods: {
    calSumLgAmt: function(value){
      this.sumLgAmt = this.appVo.lgAmt*1+this.addLgAmt*1;
    },
  },

  watch: {
    addLgAmt(newDate, oldDate) {
      this.$emit("onChildIncChange", {
        addLgAmt: this.addLgAmt,
        sumLgAmt: this.sumLgAmt,
        addPeriodStartDate: this.addPeriodStartDate,
        addPeriodEndDate: this.addPeriodEndDate,
        feeAmt:this.feeAmt,
      });
    },
    sumLgAmt(newDate, oldDate) {
      this.$emit("onChildIncChange", {
        addLgAmt: this.addLgAmt,
        sumLgAmt: this.sumLgAmt,
        addPeriodStartDate: this.addPeriodStartDate,
        addPeriodEndDate: this.addPeriodEndDate,
        feeAmt:this.feeAmt,
      });
    },
    addPeriodStartDate(newDate, oldDate) {
      this.$emit("onChildIncChange", {
        addLgAmt: this.addLgAmt,
        sumLgAmt: this.sumLgAmt,
        addPeriodStartDate: this.addPeriodStartDate,
        addPeriodEndDate: this.addPeriodEndDate,
        feeAmt:this.feeAmt,
      });
    },
    addPeriodEndDate(newDate, oldDate) {
      this.$emit("onChildIncChange", {
        addLgAmt: this.addLgAmt,
        sumLgAmt: this.sumLgAmt,
        addPeriodStartDate: this.addPeriodStartDate,
        addPeriodEndDate: this.addPeriodEndDate,
        feeAmt:this.feeAmt,
      });
    }
  }
};
</script>